import React, { useState, useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import { useAuthContext } from "../hooks/useAuthContext";
import LoadingSpinner from "../components/LoadingSpinner";
import { ApiConnectionString } from "../constants/ApiConntection";
import MemboticLogo from "../assets/MemboticLogo.png";
import MemboticLogoWhite from "../assets/MemboticLogoWhite.png";
import EmbeddedLoginOrSignUpModal from "./modals/EmbeddedLoginOrSignUpModal";
import PrivacyModal from "./modals/PrivacyModal";
import TermsModal from "./modals/TermsModal";
import axios from "axios";
import NoImagePlaceholder from "../assets/NoImagePlaceholder.png";

export default function EmbeddedProduct() {
  const { clubId, productId } = useParams();
  const { user } = useAuthContext();

  const [isLoading, setIsLoading] = useState(true);
  const [privacyModal, setPrivacyModal] = useState(false);
  const [terms, setTerms] = useState(false);

  const [club, setClub] = useState();
  const [product, setProduct] = useState({});

  const [profiles, setProfiles] = useState([]);
  const [membership, setMembership] = useState([]);
  const [bookingProfileId, setBookingProfileId] = useState(0);
  const [err, setErr] = useState("");

  const handleCheckout = async (prodId, proId) => {
 
    if (user) {
      const productId = prodId;
      const BookingProfileId = proId;
      const transaction = { productId, BookingProfileId };

      try {
        const transResponse = await axios.post(
          `${ApiConnectionString}/api/Checkout`,
          transaction,
          {
            headers: { Authorization: `Bearer ${user.token}` },
          }
        );

        if (transResponse.status === 200) {
          window.location.href = transResponse.data;
        }
      } catch (error) {
        if (error.status == 401) {
        }
        console.error("Error processing subscription:", error);
      }
    }
  };



    const handleStartSubscription = () => {
      console.log(bookingProfileId)
    if (bookingProfileId != 0) { 
      handleCheckout(productId,bookingProfileId)
    
    }
  };

  const handleSelectionChange = (event) => {
    const selectedId = parseInt(event.target.value, 10);
    setBookingProfileId(selectedId);
    setErr("");
  };

  const removeMatchingProfiles = (profiles, membership) => {
    const membershipIds = membership.map((member) => member.profileId);
    return profiles.filter((profile) => !membershipIds.includes(profile.id));
  };

  const fetchData = async () => {
    const clubResponse = await axios.get(
      `${ApiConnectionString}/api/club/${clubId}`
    );
    setClub(clubResponse.data);

    const productResponse = await axios.get(
      `${ApiConnectionString}/api/product/${productId}`
    );
    setProduct(productResponse.data);

    if (productResponse.data.recurring) {
      try {
        setBookingProfileId(0);

        const membershipResponse = await axios.get(
          `${ApiConnectionString}/api/ClubMembers/${user.id}/${clubId}`,
          { headers: { Authorization: `Bearer ${user.token}` } }
        );
        setMembership(membershipResponse.data);

        const profileResponse = await axios.get(
          `${ApiConnectionString}/api/BookingProfiles?AppUserId=${user.id}`,
          { headers: { Authorization: `Bearer ${user.token}` } }
        );

        const filteredProfiles = removeMatchingProfiles(
          profileResponse.data,
          membershipResponse.data
        );
        setProfiles(filteredProfiles);

        if (filteredProfiles.length === 1) {
          setBookingProfileId(filteredProfiles[0].id);
        }
      } catch (err) {
        console.error(err);
      }
    }
  };

  const cancelModal = () => {
    setPrivacyModal(false);
    setTerms(false);
  };

  const toGBP = (p) =>
    p == null
      ? null
      : `${club.country == "GB" ? "£" : "$"}${(p / 100).toFixed(2)}`;

  useEffect(() => {
    if (user) {
      setIsLoading(false);
      fetchData();
    }
  }, [user]);

  if (isLoading) return <LoadingSpinner />;

  if (club && product) {
    return (
      <div>
        <button
          className="floating-back-button"
          onClick={() => window.history.back()}
        >
          ← Go Back
        </button>
        <div className="bg-white">
          <div className="container">
            <div className="d-flex justify-content-center">
              <Link to="/">
                <img
                  src={MemboticLogo}
                  className="login-logo"
                  alt="Membotic All your fitness clubs and activities together"
                  title="Membotic All your fitness clubs and activities together"
                />
              </Link>
            </div>
          </div>
        </div>

        <div className="container bg-white rounded-4 shadow-sm p-4 my-4">
          {!user && <EmbeddedLoginOrSignUpModal />}

          {user && (
            <>
              <div className="row align-items-center g-4 mb-4">
                <div className="col-md-8 order-2 order-md-1">
                  <h2 className="mb-2">{club.name}</h2>
                  <p className="text-muted mb-0">{club.description}</p>
                </div>
                <div className="col-md-4 order-1 order-md-2 text-md-end">
                  <img
                    src={
                      club.image
                        ? `${ApiConnectionString}/api/ClubProfileImage/${club.id}`
                        : NoImagePlaceholder
                    }
                    alt={club.name}
                    className="img-fluid rounded-3"
                  />
                </div>
              </div>

              <div className="p-3 bg-light rounded border mb-4">
                <h5 className="mb-2 fw-bold">{product.name}</h5>
                <p className="mb-2 text-muted">{product.description}</p>
                <div className="mb-1">
                  <span className="fw-semibold">Type: </span>
                  {product.isSubscription ? "Subscription" : "One off purchase"}
                </div>
                {product.price != null && (
                  <div className="mb-1">
                    <span className="fw-semibold">Price: </span>
                    {toGBP(product.price)}
                  </div>
                )}
              </div>

              {product.totalAccess ? (
                <p className="text-success text-center">
                  This product allows access to all classes at {club.name}
                </p>
              ) : (
                <div className="text-center my-3">
                  <p className="text-muted">
                    This product allows access to selected classes at{" "}
                    {club.name}
                  </p>
                  <button className="btn btn-light border">
                    View available classes
                  </button>
                </div>
              )}

              {product.recurring ? (
                <div className="mb-3">
                  {membership.length > 0 ? (
                    <div className="mb-3">
                      <p className="mb-2">
                        The following profiles already have a membership to this
                        club, the same profile cannot subscribe to the same club
                        more than once
                      </p>
                      {membership.map((member) => (
                        <div key={member.Id} className="d-flex">
                          <p className="text-danger fw-bold mx-2 mb-1">
                            {member.viewBookingProfile.username}
                          </p>
                          <p className="mb-1">{member.name}</p>
                        </div>
                      ))}
                    </div>
                  ) : (
                    <p className="mb-3">No memberships available.</p>
                  )}

                  {profiles.length > 0 ? (
                    <>
                      <p className="fw-bold mb-2">
                        Select a profile that you want to subscribe to{" "}
                        {product.name} with
                      </p>
                      <div className="d-flex align-items-center">
                        <select
                          id="profile-select"
                          value={bookingProfileId}
                          onChange={handleSelectionChange}
                          className="form-select w-auto"
                        >
                          <option value={0}>Please choose a username</option>
                          {profiles.map((profile) => (
                            <option key={profile.id} value={profile.id}>
                              {profile.username}
                            </option>
                          ))}
                        </select>
                        <button
                          className="btn btn-primary ms-3"
                          onClick={handleStartSubscription}
                        >
                          Start subscription
                        </button>
                      </div>
                      <p className="text-danger mt-2">{err}</p>
                    </>
                  ) : (
                    <div>
                      <p>
                        All of your profiles are already subscribed to this club
                      </p>
                      <button
                        className="btn btn-outline-secondary"
                        onClick={() => window.scrollTo(0, 0)}
                      >
                        Okay
                      </button>
                    </div>
                  )}
                </div>
              ) : (
                <div className="d-grid gap-2">
                  <button
                    onClick={() => handleCheckout(productId)}
                    className="btn btn-primary btn-lg"
                  >
                    Buy now
                  </button>
                </div>
              )}
            </>
          )}
        </div>

        <div className="container-fluid bg-dark">
          <div className="pt-5 mx-5 d-flex justify-content-center">
            <Link
              onClick={() => {
                window.scrollTo(0, 0);
              }}
              to="/"
            >
              <img
                src={MemboticLogoWhite}
                className="logo"
                alt="Membotic All your fitness clubs and activities together"
                title="Membotic All your fitness clubs and activities together"
              />
            </Link>
          </div>

          <div className="row">
            <div className="d-flex justify-content-between w-100 align-items-center px-4 pb-3">
              <div className="d-flex link-hover-effect">
                <Link onClick={() => setPrivacyModal(true)}>
                  Privacy Policy
                </Link>
                <p className="text-white mx-1 mb-0">|</p>
                <Link onClick={() => setTerms(true)}>Terms Of Use</Link>
              </div>
              <div className="text-white ms-auto">
                &copy; Membotic {new Date().getFullYear()}
              </div>
            </div>
          </div>
        </div>

        {terms && <TermsModal cancelModal={cancelModal} />}
        {privacyModal && <PrivacyModal cancelModal={cancelModal} />}
      </div>
    );
  }
}
